import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { DeviceDetect } from "sb-resp-utils";
import { dict } from "./dict";
import { config } from "./config";
import { Search } from "./ui";
import { SearchState } from "./state";
import { Parser } from "../../parser";
import { Retriever } from "../../retriever";
import { internalMessageBus } from "../../ExternalDependencies";
/**
 * The bet search block appears after it is activated from a click on the
 * mobile menu.
 *
 * For performance reasons React blocks are activated after a time out.
 * The last change conflicts with the iOS Safari security policy and the focus
 * on component mount was prevented (https://jira.sbtech.com/browse/DGT-3720).
 *
 * We use `AfterSwitchPanels` event callback to focus on a fake input that is
 * removed from the DOM later. This allows us to show the native keyboard
 * after the user interaction and later when the block is activated to
 * move the focus to the mounted original search form input.
 */
window.Application.AfterSwitchPanels["SearchInputFocus"] = function (_, toPanel) {
    const a = toPanel.Blocks.find(x => x.block instanceof SearchRoot);
    const b = toPanel.Blocks.find(x => x instanceof SearchRoot);
    // Safe guard check if the block is activate using AsyncBlockInit or not
    if (!DeviceDetect.getInstance().isDesktop && (a || b)) {
        const fakeInput = document.createElement("input");
        fakeInput.id = "fake-input";
        fakeInput.setAttribute("type", "text");
        fakeInput.style.position = "absolute";
        fakeInput.style.padding = "0";
        fakeInput.style.border = "0";
        fakeInput.style.height = "0";
        fakeInput.style.opacity = "0";
        fakeInput.style.fontSize = "16px"; // disable auto zoom
        if (!document.getElementById("fake-input")) {
            // you may need to append to another element depending on the browser's auto
            // zoom/scroll behavior
            document.body.prepend(fakeInput);
        }
        fakeInput.focus();
    }
};
export class SearchRoot extends BaseBlock {
    constructor(domId, options) {
        super(domId, options);
        this.containerElement = options.containerElement;
        const dictionary = Object.assign(Object.assign({}, dict), (options.dict || {}));
        const cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        const retriever = new Retriever(options.dataProvider, this.options.regionCode, this.options.sportConfigs);
        const parser = new Parser(retriever, internalMessageBus, dictionary, this.options.navHandler, this.options.dateTimeData, cms);
        this.dataProvider = new SearchState({
            cms,
            dict: dictionary,
            navHandler: this.options.navHandler,
            currentLangCode: this.options.currentLangCode,
            provider: parser
        });
        this.props = { dataProvider: this.dataProvider };
    }
    beforeActivate() {
        this.dataProvider.activate();
        return this;
    }
    activate() {
        this.containerElement.classList.add("bet-search-active");
        return super.activate(React.createElement(Search, Object.assign({}, this.props)));
    }
    afterActivate() {
        return super.afterActivate();
    }
    beforeDeactivate() {
        this.dataProvider.deactivate();
        return this;
    }
    deactivate() {
        this.containerElement.classList.remove("bet-search-active");
        return super.deactivate();
    }
}
window["Search"] = SearchRoot;
broadcastBlockLoad("Search");
//# sourceMappingURL=index.js.map